<div class="app-dialog em">

  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="em-ico" aria-hidden="true"><span class="material-icons">edit_note</span></span>
      <div>
        <p class="app-dialog__eyebrow">Gestión de Riesgos</p>
        <h2>Editar la matriz</h2>
        <p>{{ borrador.nombre || 'Matriz de riesgos' }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close em-cerrar" (click)="cancelar()" [disabled]="guardando"
            aria-label="Cerrar" title="Cerrar">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div class="app-dialog__content em-contenido">
    <div class="em-error" *ngIf="error" role="alert">
      <span class="material-icons" aria-hidden="true">error_outline</span>{{ error }}
    </div>

    <div class="em-rejilla">
      <mat-form-field appearance="outline" class="table-page__field em-ancho" subscriptSizing="dynamic">
        <mat-label>Nombre</mat-label>
        <input matInput aria-label="Nombre" type="text" maxlength="50" required [(ngModel)]="borrador.nombre" name="nombre"
               placeholder="Ej. Matriz de Riesgos Recursos Humanos" />
        <mat-hint>Es el nombre con el que aparece en el tablero. Máximo 50 caracteres.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Área</mat-label>
        <select matNativeControl aria-label="Área" [(ngModel)]="borrador.idCatArea" name="idCatArea">
          <option [ngValue]="null">Sin área</option>
          <option *ngFor="let a of areas" [ngValue]="a.id">{{ a.area }}</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Proceso</mat-label>
        <input matInput aria-label="Proceso" type="text" maxlength="200" [(ngModel)]="borrador.proceso" name="proceso" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field em-ancho" subscriptSizing="dynamic">
        <mat-label>Alcance</mat-label>
        <input matInput aria-label="Alcance" type="text" maxlength="200" [(ngModel)]="borrador.alcance" name="alcance"
               placeholder="Qué cubre esta matriz" />
      </mat-form-field>
    </div>

    <p class="em-lbl" id="emActivos">¿Trabaja con activos?</p>
    <div class="em-ops" role="radiogroup" aria-labelledby="emActivos" [class.es-bloqueado]="activosBloqueados">
      <button type="button" class="em-op" *ngFor="let o of OPCIONES_ACTIVOS" role="radio"
              [class.es-activa]="borrador.aplicaActivos === o.valor"
              [attr.aria-checked]="borrador.aplicaActivos === o.valor"
              [disabled]="activosBloqueados"
              (click)="elegirActivos(o.valor)">
        <span class="material-icons em-op__marca" aria-hidden="true">
          {{ borrador.aplicaActivos === o.valor ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </span>
        <span class="em-op__txt"><b>{{ o.titulo }}</b><small>{{ o.texto }}</small></span>
      </button>
    </div>

    <!-- Con activos capturados ya no se cambia: apagarlo los dejaría sin
         pantalla donde verlos (29/09/2026). -->
    <p class="em-nota em-nota--candado" *ngIf="activosBloqueados">
      <span class="material-icons" aria-hidden="true">lock</span>
      <ng-container *ngIf="totalActivos !== null; else revisando">
        Ya tiene {{ totalActivos }} {{ totalActivos === 1 ? 'activo capturado' : 'activos capturados' }}:
        esto ya no se cambia, para no perder su información.
      </ng-container>
      <ng-template #revisando>Revisando si ya tiene activos capturados…</ng-template>
    </p>
    <p class="em-nota" *ngIf="!activosBloqueados && !apagaSinActivos">
      Los activos vienen del Inventario de IA: hoy solo los usa la matriz de IA. Las demás áreas
      gestionan sus riesgos de proceso, con su expediente y sus evidencias.
    </p>
    <p class="em-nota" *ngIf="apagaSinActivos">
      Se quita la pestaña de Activos. No tiene activos capturados, así que no se pierde nada.
    </p>

    <!-- Avisos de monitoreo (29/09/2026): cada matriz tiene su gente. Es
         solo en pantalla: a quien esté aquí, el tablero le muestra lo que le
         toca monitorear de esta matriz, desde 5 días antes y mientras siga
         vencido. Solo aparecen quienes abren el tablero. -->
    <p class="em-lbl" id="emAvisos">Avisos de monitoreo</p>
    <p class="em-nota em-nota--arriba">
      A quien marques, el tablero de Gestión de Riesgos le avisa qué le toca monitorear de esta
      matriz: desde 5 días antes y mientras siga vencido.
    </p>
    <p class="em-nota" *ngIf="cargandoAvisos">Consultando quién puede recibir avisos…</p>
    <p class="em-nota em-nota--error" *ngIf="avisosError" role="alert">{{ avisosError }}</p>
    <div class="em-personas" role="group" aria-labelledby="emAvisos"
         *ngIf="!cargandoAvisos && !avisosError && candidatos.length">
      <button type="button" class="em-persona" *ngFor="let c of candidatos" role="checkbox"
              [class.es-activa]="avisados.has(c.idUsuario)" [attr.aria-checked]="avisados.has(c.idUsuario)"
              [disabled]="guardando" (click)="alternarAviso(c.idUsuario)">
        <span class="material-icons em-persona__marca" aria-hidden="true">
          {{ avisados.has(c.idUsuario) ? 'check_box' : 'check_box_outline_blank' }}
        </span>
        <span class="em-persona__txt">
          <b>{{ c.nombre || c.userNom }}</b>
          <small>{{ c.userNom }}</small>
        </span>
      </button>
    </div>
    <p class="em-nota" *ngIf="!cargandoAvisos && !avisosError">
      <ng-container *ngIf="avisados.size === 0">Nadie recibe todavía los avisos de esta matriz.</ng-container>
      <ng-container *ngIf="avisados.size === 1">1 persona recibe los avisos de esta matriz.</ng-container>
      <ng-container *ngIf="avisados.size > 1">{{ avisados.size }} personas reciben los avisos de esta matriz.</ng-container>
    </p>
  </div>

  <footer class="app-dialog__footer">
    <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
            (click)="cancelar()" [disabled]="guardando">Cancelar</button>
    <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
            (click)="guardar()" [disabled]="guardando">
      <span class="material-icons" aria-hidden="true">save</span>
      {{ guardando ? 'Guardando…' : 'Guardar cambios' }}
    </button>
  </footer>
</div>
